<div class="rota-detalhes-relatorio-container">
  <mat-table [dataSource]="resumoPOIsDataSource" multiTemplateDataRows class="relatorio-table" #tableRelatorio>
    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef class="col-status"></mat-header-cell>
      <mat-cell *matCellDef="let element" class="col-status">
        <app-state-circle [matTooltip]="element.iconStatus" matTooltipPosition="above" [visit]="element.icon">
        </app-state-circle>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="numeroOrdem">
      <mat-header-cell *matHeaderCellDef class="col-ordem">{{ 'ROUTE_REPORT.REPORT.PROPERTIES.NUMBER' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="col-ordem"> {{element.ordem}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="codigo">
      <mat-header-cell *matHeaderCellDef class="col-codigo">{{ 'ROUTE_REPORT.REPORT.PROPERTIES.CODE' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="col-codigo"> {{element.codigo}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="imagem">
      <mat-header-cell *matHeaderCellDef class="col-icon">{{ 'ROUTE_REPORT.REPORT.PROPERTIES.IMAGE' | translate }}</mat-header-cell>
      <mat-cell [matTooltipDisabled]="!((docLoaded$ | async) ?? 0) || possuiImg(element.codigo)" matTooltip="{{ 'ROUTE_REPORT.REPORT.NO_IMG' | translate }}" *matCellDef="let element" class="col-icon">
        <button (click)="downloadImg(element.codigo)" *ngIf="(docLoaded$ | async) else LoadIcon" [disabled]="!possuiImg(element.codigo)" mat-icon-button>
          <mat-icon *ngIf="possuiAss(element.codigo); else disabledIcon" fontSet="material-icons-outlined" svgIcon="seta_download"></mat-icon>
          <ng-template #disabledIcon>
            <mat-icon svgIcon="seta_download" style="color: #D0D4DC !important;"></mat-icon>
          </ng-template>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="assinatura">
      <mat-header-cell *matHeaderCellDef class="col-icon">{{ 'ROUTE_REPORT.REPORT.PROPERTIES.SIGNATURE' | translate }}</mat-header-cell>
      <mat-cell [matTooltipDisabled]="!((docLoaded$ | async) ?? 0) || possuiAss(element.codigo)" matTooltip="{{ 'ROUTE_REPORT.REPORT.NO_SIG' | translate }}" *matCellDef="let element" class="col-icon">
        <button (click)="downloadAss(element.codigo)" *ngIf="(docLoaded$ | async) else LoadIcon" [disabled]="!possuiAss(element.codigo)" mat-icon-button>
          <mat-icon *ngIf="possuiAss(element.codigo); else disabledIcon" fontSet="material-icons-outlined" svgIcon="seta_download"></mat-icon>
          <ng-template #disabledIcon>
            <mat-icon svgIcon="seta_download" style="color: #D0D4DC !important;"></mat-icon>
          </ng-template>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="cliente">
      <mat-header-cell *matHeaderCellDef class="col-cliente">{{ 'ROUTE_REPORT.REPORT.PROPERTIES.CLIENT' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="col-cliente">
        {{element.razaoSocial ?? '-'}}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="inicio">
      <mat-header-cell *matHeaderCellDef class="col-horarios">{{ 'ROUTE_REPORT.REPORT.PROPERTIES.START' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="col-horarios">
        <div class="horarios">
          <div class="planejado">
            {{element.horaChegada.planejado || emptyDate}}
          </div>

          <div class="executado">
            {{element.chegada || emptyDate}}
          </div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="saida">
      <mat-header-cell *matHeaderCellDef class="col-horarios">{{ 'ROUTE_REPORT.REPORT.PROPERTIES.DEPARTURE' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="col-horarios">
        <div class="horarios">
          <div class="planejado">
            {{element.horaSaida.planejado || emptyDate}}
          </div>

          <div class="executado">
            {{element.saida || emptyDate}}
          </div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-template #LoadIcon>
      <ngx-skeleton-loader appearance="circle" [theme]="theme"></ngx-skeleton-loader>
    </ng-template>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" class="border-default"
        [class.relatorio-collapsed]="!element.removido && !element.adicionado"
        [class.rel-expansion]="element.removido || element.adicionado">
        <div class="expansion-container">
          <div *ngIf="element.adicionado" class="mat-h4 title add-title">
            {{ 'ROUTE_REPORT.REPORT.ADDED' | translate }}
          </div>
          <div *ngIf="element.removido" class="mat-h4 title del-title">
            {{ 'ROUTE_REPORT.REPORT.REMOVED' | translate }}
          </div>
          <div class="msg-text">
            {{element.descricao}}
          </div>
        </div>
      </td>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" class="visitas-row"
           [class.removido]="row.removido" [class.adicionado]="row.adicionado">
  </mat-row>
  </mat-table>

  <ngx-skeleton-loader [theme]="{'height.rem': 1.8}" count="5" *ngIf="!loaded"></ngx-skeleton-loader>
</div>
